import { match } from 'ts-pattern'

export function matchStatusToIcon(status: string) {
  return match(status)
    .with(
      'sent',
      () =>
        'https://spothopper-static.s3.amazonaws.com/assets/admin/inquiries_page/contract_status_sent.svg',
    )
    .with(
      'viewed',
      () =>
        'https://spothopper-static.s3.amazonaws.com/assets/admin/inquiries_page/contract_status_viewed.svg',
    )
    .with(
      'signed',
      () =>
        'https://spothopper-static.s3.amazonaws.com/assets/admin/inquiries_page/contract_status_signed.svg',
    )
    .with(
      'expired',
      () =>
        'https://spothopper-static.s3.amazonaws.com/assets/admin/inquiries_page/contract_status_expired.svg',
    )
    .with(
      'declined',
      () =>
        'https://spothopper-static.s3.amazonaws.com/assets/admin/inquiries_page/contract_status_declined.svg',
    )
    .with(
      'uploaded',
      () =>
        'https://spothopper-static.s3.amazonaws.com/assets/admin/inquiries_page/contract_status_uploaded.svg',
    )
    .otherwise(
      () =>
        'https://spothopper-static.s3.amazonaws.com/assets/admin/inquiries_page/contract_status_viewed.svg',
    )
}
